import React, { Component } from 'react';
import PortalTextBox from '../../../portal/portalTextBox';
import { LdapGroupDnTooltip } from '../../forms/ldapHelpTooltipContent';
import RolesDropdownContainer from '../../../portal/rolesDropdownContainer';
import { TrashButton } from '@checkmarx/cx-ui';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import styles from './style.scss';

@observer
export default class AdvancedRoleMapping extends Component {

    removeMapping = () => {

        this.props.ldapRoleMappingsStore.removeMapping(this.props.mapping.id);
    }

    handleChangeRoleId = (e, index, roleId) => {

        this.props.ldapRoleMappingsStore.setMappingRole(this.props.mapping.id, roleId);
        this.props.ldapRoleMappingsStore.validateMappingRoleId(this.props.mapping.id, roleId);
    }

    handleChangeGroupDn = e => {

        this.props.ldapRoleMappingsStore.setMappingGroupDn(this.props.mapping.id, e.target.value);
    }

    handleGroupDnBlur = e => {

        this.props.ldapRoleMappingsStore.validateMappingGroupDn(this.props.mapping.id);
    }

    render() {

        return (
            <div className={classNames(styles.advancedRoleMapping)} style={this.props.style}>
                <RolesDropdownContainer
                    dataCy='ddl-roles'
                    hintText={this.props.translations.cxRole}
                    floatingLabelText={this.props.translations.cxRole}
                    width='45%'
                    onChange={this.handleChangeRoleId}
                    errorText={this.props.mapping.roleIdValidationMessage}
                    value={this.props.mapping.roleId}
                    helpTooltipText={this.props.translations.cxRoleTooltip}
                />

                <PortalTextBox
                    dataCy='txt-ldap-group-dn'
                    hintText={this.props.translations.ldapGroupDn}
                    floatingLabelText={this.props.translations.ldapGroupDn}
                    width='45%'
                    onChange={this.handleChangeGroupDn}
                    onBlur={this.handleGroupDnBlur}
                    errorText={this.props.mapping.groupDnValidationMessage}
                    value={this.props.mapping.ldapGroupDn}
                    helpTooltipText={<LdapGroupDnTooltip />}
                />
                <TrashButton className={classNames(styles.deleteAdvancedRoleMapping)}
                    dataCy='btn-trash'
                    width='5%'
                    onClick={this.removeMapping} />
            </div>
        );
    }
}